import {
  EpicWinConfiguration,
  EpicWinPopupProvider,
  EpicWinStep,
  EpicWinStepName,
} from '@cgs/machines';
import { SantaEpicWinPopupController } from './santa-epic-win-popup.controller';
import { SantaEpicWinPopupView } from './santa-epic-win-popup.view';
import { Container } from '@cgs/wge';

const epicWinConfiguration = new EpicWinConfiguration(
  [
    new EpicWinStep(1, EpicWinStepName.BigWin, 2.0, 30, 50),
    new EpicWinStep(2, EpicWinStepName.MegaWin, 2.0, 50, 70),
    new EpicWinStep(3, EpicWinStepName.EpicWin, 2.0, 70, 10000),
  ],
  0.0,
  0.0,
  0.8
);

export class SantaEpicWinPopupProvider extends EpicWinPopupProvider {
  constructor(container: Container) {
    super(container, { configuration: epicWinConfiguration });
  }

  protected createController(): void {
    const view = new SantaEpicWinPopupView(
      this.container,
      this.rootScene,
      this.popupScene,
      this.popupSoundScene!,
      epicWinConfiguration
    );
    this.popupController = new SantaEpicWinPopupController(
      this.container,
      view,
      epicWinConfiguration,
      true,
      this.startAfterShortWinLines
    );
  }
}
